<template>
  <NsSlottedDropdown
    class="ns-product-variant-selector"
    :label="label"
    :disabled="disabled"
    :placeholder="placeholder"
    :selected="selectedSku"
    :tall="tall"
    data-testid="variantSelector"
    @select="handleSelect"
  >
    <div
      v-for="item in variants"
      :key="item.id"
      class="ns-product-variant-selector__item"
      :data-value="item.sku"
    >
      <div
        v-if="!!item.shade"
        class="ns-product-variant-selector__shade"
        :style="{ backgroundColor: item.shade }"
      />
      <div class="ns-product-variant-selector__label">
        {{ item.variantDropdownLabel }}
      </div>
    </div>
  </NsSlottedDropdown>
</template>

<script>
import { NsSlottedDropdown } from "@nuskin/design-components";

/**
 * NsProductVariantSelector
 *
 * How to use:
 *
 * @event select  When a selection occurs this event emits a function with
 * params: (value, index)
 */

export default {
  name: "NsProductVariantSelector",
  components: { NsSlottedDropdown },
  props: {
    /**
     * Disables input
     */
    disabled: Boolean,
    /**
     * Label
     */
    label: {
      type: String,
      default: ""
    },
    /**
     * Placeholder text
     */
    placeholder: {
      type: String,
      default: ""
    },
    /**
     * Sku of the current product
     */
    selectedSku: {
      type: String,
      default: ""
    },
    /**
     * Makes the component taller to match button height
     */
    tall: Boolean,
    /**
     * Array of variant skus
     */
    variantSkus: {
      type: Array,
      default() {
        return [];
      }
    },
    /**
     * Array of variant options. Should be {id, sku, shade, label}
     */
    variants: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  methods: {
    /**
     * Disables input
     */
    disable() {
      this.disabled = true;
    },
    /**
     * Enables input
     */
    enable() {
      this.disabled = false;
    },
    /**
     * Handle variant selection
     */
    handleSelect(value, index) {
      // if (!data.pristine && !this.settingVariants) {
      this.$emit("select", value, index);
      // this.variantIndex = data.index;
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/global.mixins";
@use "~@nuskin/ns-core-styles/src/scss/colors";

* {
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

.ns-product-variant-selector {
  margin: 0;
  display: block;
  width: 100%;
}

.ns-product-variant-selector__item {
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;

  &:hover {
    background-color: map.get(colors.$themeColors, color-interactive-5);
  }
}

.ns-product-variant-selector__shade {
  height: 20px;
  width: 20px;
  border-radius: 50%;
  display: inline-block;
}

.ns-product-variant-selector__label {
  flex: 1;
  display: inline-block;
  margin-left: 10px;
  @include global.p-small;
  text-align: left;
}
</style>
